import type { PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import { Rotulo3D } from '../componentes/Rotulo3D'
import { useDeformacao } from './contextoDeformacao'

/** abaixo disto o dano não ganha rótulo, em metros */
const MINIMO_M = 0.02

const cm = (m: number) => `${Math.round(m * 100)} cm`

/**
 * Leitura do dano estrutural com a lataria sólida.
 *
 * O raio-X das barras mostra ONDE a estrutura se deformou; aqui vai o quanto,
 * para o que mais pesa no salvamento: longarinas (recuo e flambagem) e coluna B
 * (intrusão). Números do mesmo campo que deforma a geometria — didáticos, não
 * medida pericial.
 */
export function DanoEstrutural3D({ perfil }: { perfil: PerfilVeiculo }) {
  const ctx = useDeformacao()
  if (!ctx?.raioXEstrutural) return null
  const hw = perfil.largura / 2
  const rotulos: { chave: string; posicao: [number, number, number]; texto: string }[] = []
  for (const [sinal, sufixo, nome] of [
    [1, 'Esquerda', 'esquerda'],
    [-1, 'Direita', 'direita'],
  ] as const) {
    const longarina = ctx.pecas[`longarina${sufixo}`]
    if (longarina && longarina.recuo > MINIMO_M) {
      rotulos.push({
        chave: `longarina${sufixo}`,
        posicao: [sinal * (hw + 0.15), perfil.pisoY + 0.1, perfil.frenteZ - 0.5],
        texto:
          `longarina ${nome}: recuo ${cm(longarina.recuo)}` +
          (longarina.flambagem > MINIMO_M ? ` • flambagem ${cm(longarina.flambagem)}` : ''),
      })
    }
    const colunaB = ctx.pecas[`colunaB${sufixo}`]
    if (colunaB && colunaB.recuo > MINIMO_M) {
      rotulos.push({
        chave: `colunaB${sufixo}`,
        posicao: [sinal * (hw + 0.2), perfil.cinturaY + 0.1, perfil.colunaB.z],
        texto: `coluna B ${nome}: intrusão ${cm(colunaB.recuo)}`,
      })
    }
  }
  return (
    <group>
      {rotulos.map((r) => (
        // a lataria sólida é ligada de propósito: a leitura do dano aparece com ela
        <Rotulo3D key={r.chave} posicao={r.posicao} texto={r.texto} variante="risco" fator={5} sempreVisivel />
      ))}
    </group>
  )
}
